import { Pivot, PivotItem } from '@fluentui/react';
import * as React from 'react'
import { useTranslation } from 'react-i18next';
import { LeftMenuContext } from '../../../context/leftMenu.context';
import "../../../css/components/products.scss"
import ProductType from './producType';
import Category from './category';
import Brand from './brand';
import Product from './product';
const Products = () => {
  const { t } = useTranslation();
  // const [selectedKey, setSelectedKey] = React.useState('Product');
  const { setSelectedMenuItem } = React.useContext(LeftMenuContext);
  React.useEffect(() => {
    setSelectedMenuItem("Products")
  }, []);
  return (
    <>
      <Pivot className="tab-header">
        <PivotItem headerText={t('Product')} itemKey="Product"  >
          <Product></Product>
        </PivotItem>
        <PivotItem headerText={t('Category')} itemKey="Category" >
          <Category></Category>
        </PivotItem>
        <PivotItem headerText={t('Brand')} itemKey="Brand" >
          <Brand></Brand>
        </PivotItem>
        <PivotItem headerText={t('ProductType')} itemKey="ProductType" >
          <ProductType></ProductType>
        </PivotItem>
      </Pivot>
    </>
  );
}
export default Products;